import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { SubscribableOrNullableValue } from 'knockout';
import { Person } from '../../../models/person';
import AvatarConfig from '../avatar/avatarConfig';
import './person.html';
import './person.scss';

export interface PersonAvatarVMConfig {
    person: SubscribableOrNullableValue<Person>
}

@injectable()
export default class PersonAvatarVM {
    avatarConfig: AvatarConfig

    constructor(
        @inject(wccModules.componentConfig) config: PersonAvatarVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
    ) {
        const person = ko.flattenComputed(config.person);

        const imageUrl = person.proxy(u => u.imageURL);

        const isModerator = person.pluck(u => u.isModerator, false);
        const isObserver = person.pluck(u => u.isObserver, false);

        this.avatarConfig = {
            imageUrl: imageUrl,
            isModerator: isModerator,
            isObserver: isObserver
        }

        ko.applyBindingsToNode(info.element, {
            'visible': person.isNotNull(),

            'css': {
                'person-avatar': true
            }
        });
    }
}